import { Routes } from '@angular/router';
import { AuthGuardService } from './servicios/auth-guard.service';
const ɵ0 = () => import("./home/home.module.ngfactory").then(m => m.HomePageModuleNgFactory), ɵ1 = () => import("./pages/login/login.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ2 = () => import("./pages/directorios/directorios.module.ngfactory").then(m => m.DirectoriosPageModuleNgFactory), ɵ3 = () => import("./pages/visor-pdf/visor-pdf.module.ngfactory").then(m => m.VisorPdfPageModuleNgFactory), ɵ4 = () => import("./pages/visor-pdf/visor-pdf.module.ngfactory").then(m => m.VisorPdfPageModuleNgFactory), ɵ5 = () => import("./pages/visor-plantillas/visor-plantillas.module.ngfactory").then(m => m.VisorPlantillasPageModuleNgFactory), ɵ6 = () => import("./pages/verificador/verificador.module.ngfactory").then(m => m.VerificadorPageModuleNgFactory), ɵ7 = () => import("./pages/formulario/formulario.module.ngfactory").then(m => m.FormularioPageModuleNgFactory), ɵ8 = () => import("./pages/quienes-somos/quienes-somos.module.ngfactory").then(m => m.QuienesSomosPageModuleNgFactory), ɵ9 = () => import("./pages/tarifas/tarifas.module.ngfactory").then(m => m.TarifasPageModuleNgFactory), ɵ10 = () => import("./pages/contacto/contacto.module.ngfactory").then(m => m.ContactoPageModuleNgFactory), ɵ11 = () => import("./pages/proteccion-datos/proteccion-datos.module.ngfactory").then(m => m.ProteccionDatosPageModuleNgFactory), ɵ12 = () => import("./pages/aviso-legal/aviso-legal.module.ngfactory").then(m => m.AvisoLegalPageModuleNgFactory), ɵ13 = () => import("./pages/cookies/cookies.module.ngfactory").then(m => m.CookiesPageModuleNgFactory), ɵ14 = () => import("./pages/csv/csv.module.ngfactory").then(m => m.CsvPageModuleNgFactory), ɵ15 = () => import("./pages/contratar/contratar.module.ngfactory").then(m => m.ContratarPageModuleNgFactory), ɵ16 = () => import("./pages/contratar/contratar.module.ngfactory").then(m => m.ContratarPageModuleNgFactory), ɵ17 = () => import("./pages/acceso-empresas/acceso-empresas.module.ngfactory").then(m => m.AccesoEmpresasPageModuleNgFactory), ɵ18 = () => import("./pages/directorio-receptores/directorio-receptores.module.ngfactory").then(m => m.DirectorioReceptoresPageModuleNgFactory), ɵ19 = () => import("./pages/avisos/avisos.module.ngfactory").then(m => m.AvisosPageModuleNgFactory), ɵ20 = () => import("./pages/directorios/directorios.module.ngfactory").then(m => m.DirectoriosPageModuleNgFactory), ɵ21 = () => import("./pages/firmas/firmas.module.ngfactory").then(m => m.FirmasPageModuleNgFactory), ɵ22 = () => import("./pages/directorio-agentes/directorio-agentes.module.ngfactory").then(m => m.DirectorioAgentesPageModuleNgFactory), ɵ23 = () => import("./pages/descargar-pdf/descargar-pdf.module.ngfactory").then(m => m.DescargarPdfPageModuleNgFactory), ɵ24 = () => import("./pages/copiar-ficheros/copiar-ficheros.module.ngfactory").then(m => m.CopiarFicherosPageModuleNgFactory), ɵ25 = () => import("./pages/control-biometrico/control-biometrico.module.ngfactory").then(m => m.ControlBiometricoPageModuleNgFactory), ɵ26 = () => import("./pages/compra/compra.module.ngfactory").then(m => m.CompraPageModuleNgFactory), ɵ27 = () => import("./pages/visor-csv/visor-csv.module.ngfactory").then(m => m.VisorCsvPageModuleNgFactory);
const routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', loadChildren: ɵ0 },
    {
        path: 'login',
        loadChildren: ɵ1
    },
    /*{
      path: 'directorio',
      loadChildren: () => import('./pages/directorio/directorio.module').then( m => m.DirectorioPageModule),
      canActivate: [AuthGuardService]
    },*/
    {
        path: 'directorio',
        loadChildren: ɵ2,
        canActivate: [AuthGuardService]
    },
    {
        path: 'visor-pdf/:id/:force',
        loadChildren: ɵ3,
        canActivate: [AuthGuardService]
    },
    {
        path: 'visor-pdf/:id',
        loadChildren: ɵ4,
        canActivate: [AuthGuardService]
    },
    {
        path: 'visor-plantillas/:id',
        loadChildren: ɵ5,
        canActivate: [AuthGuardService]
    },
    {
        path: 'verificador/:id',
        loadChildren: ɵ6
    },
    {
        path: 'formulario/:id',
        loadChildren: ɵ7
    },
    {
        path: 'somos',
        loadChildren: ɵ8
    },
    {
        path: 'tarifas',
        loadChildren: ɵ9
    },
    {
        path: 'contacto',
        loadChildren: ɵ10
    },
    {
        path: 'proteccion-datos',
        loadChildren: ɵ11
    },
    {
        path: 'legal',
        loadChildren: ɵ12
    },
    {
        path: 'cookies',
        loadChildren: ɵ13
    },
    {
        path: 'csv',
        loadChildren: ɵ14
    },
    {
        path: 'contratar/:pack/:rellenable/:plataforma',
        loadChildren: ɵ15
    },
    {
        path: 'contratar',
        loadChildren: ɵ16
    },
    {
        path: 'empresa/:empresa',
        loadChildren: ɵ17
    },
    {
        path: 'directorio-receptores',
        loadChildren: ɵ18,
        canActivate: [AuthGuardService]
    },
    {
        path: 'avisos/:id',
        loadChildren: ɵ19
    },
    {
        path: 'directorios',
        loadChildren: ɵ20,
        canActivate: [AuthGuardService]
    },
    {
        path: 'firmas',
        loadChildren: ɵ21
    },
    {
        path: 'directorio-agentes',
        loadChildren: ɵ22,
        canActivate: [AuthGuardService]
    },
    {
        path: 'descargar-pdf/:id_generado/:rol/:id_usuario',
        loadChildren: ɵ23
    },
    {
        path: 'copiar-ficheros',
        loadChildren: ɵ24,
        canActivate: [AuthGuardService]
    },
    {
        path: 'control-biometrico/:firmante/:rol/:id_generado/:forzado/:volver',
        loadChildren: ɵ25,
        canActivate: [AuthGuardService]
    },
    {
        path: 'compra',
        loadChildren: ɵ26
    },
    {
        path: 'visor-csv',
        loadChildren: ɵ27
    },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27 };
